import cx from 'classnames'
import './App.scss';
import {useEffect, useRef, useState} from "react";
import TranslationProvider, {changeLanguage} from "./modules/Translations/TranslationProvider";
import {useTranslation} from "react-i18next";
import ScalingWrapper from "./modules/Scaling/ScalingWrapper";
import {makeImagesNotDraggable} from "./utilites/img-ut";
import './modules/Animations/Animations.scss'
import ExitPage from "./views/ExitPage/ExitPage";
import MenuPage from "./views/MenuPage/MenuPage";
import useSounds from "./modules/Sounds/Sounds";
import NewGamePage from "./views/NewGamePage/NewGamePage";
import PCScreenPage from "./views/PCScreenPage/PCScreenPage";
import BedroomPage from "./views/BedroomPage/BedroomPage";
import Header from "./views/Header/Header";
import KitchenPage from "./views/KitchenPage/KitchenPage";
import FridgePage from "./views/FridgePage/FridgePage";
import CreditsPage from "./views/CreditsPage/CreditsPage";
import EndGamePage from "./views/EndGamePage/EndGamePage";
import {findKeyByValue} from "./helpers/objects";
import Loader from "./views/Loader/Loader";

import src from "./sounds/maintheme.mp3"
import srcRevers from "./sounds/mainthemeRevers.mp3"
import tomato from "./views/assets/products/tomato.png";
import banana from "./views/assets/products/banana.png";
import peach from "./views/assets/products/peach.png";
import cheescacke from "./views/assets/products/cheescacke.png";
import cheese from "./views/assets/products/cheese.png";
import salami from "./views/assets/products/salami.png";
import sausages from "./views/assets/products/sausages.png";
import egg from "./views/assets/products/egg.png";
import jam from "./views/assets/products/jem.png";
import papper from "./views/assets/products/papper.png";
import milk from "./views/assets/products/milk.png";
import cola from "./views/assets/products/cola.png";
import focus from "./views/assets/products/focus.png";
import dory from "./views/assets/products/dory.png";
import flakes from "./views/assets/products/flakes.png";
import spickers from "./views/assets/products/spickers.png";
import energy from "./views/assets/products/energy.png";

const BAR_NOT_SHOW_IN = [
  "ExitPage",
  "MenuPage",
  "NewGamePage",
  "CreditsPage",
  "EndGamePage",
]

const REVERS_MUSIC = [
  "NewGamePage",
  "PCScreenPage",
  "FridgePage",
]

const PRODUCTS_TEMPLATE = {
  3: [
    {
      id: 'tomato',
      onTrash: false,
      days: 2,
      src: tomato,
      its: "Tomato!",
      pieces: 1,
      value: 30
    },
    {
      id: 'banana',
      onTrash: false,
      days: 2,
      src: banana,
      its: "Banana!",
      pieces: 1,
      value: 30,
    },
    {
      id: 'peach',
      onTrash: false,
      days: 2,
      src: peach,
      its: "Peach!",
      pieces: 1,
      value: 20
    },
    {
      id: 'cheese',
      onTrash: false,
      days: 5,
      src: cheese,
      its: "Cheese!",
      pieces: 2,
      value: 50
    },
    {
      id: 'salami',
      onTrash: false,
      days: 5,
      src: salami,
      its: "Salami!",
      pieces: 2,
      value: 50
    },
    {
      id: 'egg',
      onTrash: false,
      days: 7,
      src: egg,
      its: "Egg!",
      pieces: 1,
      value: 40
    },
    {
      id: 'paper',
      onTrash: false,
      days: 3,
      src: papper,
      its: "Pepper!",
      pieces: 1,
      value: 30
    },
    {
      id: 'peach',
      onTrash: false,
      days: 3,
      src: peach,
      its: "Peach!",
      pieces: 1,
      value: 0
    },
    {
      id: 'milk',
      onTrash: false,
      days: 4,
      src: milk,
      its: "Milk!",
      pieces: 2,
      value: 20
    },

    {
      id: 'dory',
      onTrash: false,
      days: 3,
      src: dory,
      its: "Dory yogurt!",
      pieces: 1,
      value: 40
    },
    {
      id: 'spickers',
      onTrash: false,
      days: 99,
      src: spickers,
      its: "Spickers bar!",
      pieces: 1,
      value: 60,
    },
    {
      id: 'energy',
      onTrash: false,
      days: 99,
      src: energy,
      its: "Energy drink!",
      pieces: 1,
      value: 20,
    },
  ],
  5: [
    {
      id: 'tomato',
      onTrash: false,
      days: 2,
      src: tomato,
      its: "Tomato!",
      pieces: 1,
      value: 30
    },
    {
      id: 'banana',
      onTrash: false,
      days: 2,
      src: banana,
      its: "Banana!",
      pieces: 1,
      value: 30,
    },
    {
      id: 'peach',
      onTrash: false,
      days: 2,
      src: peach,
      its: "Peach!",
      pieces: 1,
      value: 20
    },
    {
      id: 'cheescacke',
      onTrash: false,
      days: 4,
      src: cheescacke,
      its: "Cheesecake desert!",
      pieces: 1,
      value: 40
    },
    {
      id: 'cheese',
      onTrash: false,
      days: 5,
      src: cheese,
      its: "Cheese!",
      pieces: 2,
      value: 50
    },
    {
      id: 'sausages',
      onTrash: false,
      days: 5,
      src: sausages,
      its: "Sausages!",
      pieces: 3,
      value: 60
    },
    {
      id: 'egg',
      onTrash: false,
      days: 7,
      src: egg,
      its: "Egg!",
      pieces: 1,
      value: 40
    },
    {
      id: 'egg2',
      onTrash: false,
      days: 7,
      src: egg,
      its: "Egg!",
      pieces: 1,
      value: 40
    },
    {
      id: 'jam',
      onTrash: false,
      days: 99,
      src: jam,
      its: "Jam",
      pieces: 3,
      value: 30
    },
    {
      id: 'paper',
      onTrash: false,
      days: 3,
      src: papper,
      its: "Pepper!",
      pieces: 1,
      value: 30
    },
    {
      id: 'peach',
      onTrash: false,
      days: 3,
      src: peach,
      its: "Peach!",
      pieces: 1,
      value: 0
    },
    {
      id: 'milk',
      onTrash: false,
      days: 4,
      src: milk,
      its: "Milk!",
      pieces: 2,
      value: 20
    },
    {
      id: 'focus',
      onTrash: false,
      days: 99,
      src: focus,
      its: "Focus lemonade!",
      pieces: 2,
      value: 20
    },
    {
      id: 'dory',
      onTrash: false,
      days: 3,
      src: dory,
      its: "Dory yogurt!",
      pieces: 1,
      value: 40
    },
    {
      id: 'dory2',
      onTrash: false,
      days: 3,
      src: dory,
      its: "Dory yogurt!",
      pieces: 1,
      value: 40
    },
    {
      id: 'spickers',
      onTrash: false,
      days: 99,
      src: spickers,
      its: "Spickers bar!",
      pieces: 1,
      value: 60,
    },
    {
      id: 'energy',
      onTrash: false,
      days: 99,
      src: energy,
      its: "Energy drink!",
      pieces: 1,
      value: 20,
    },
  ],
  7: [
    {
      id: 'tomato',
      onTrash: false,
      days: 2,
      src: tomato,
      its: "Tomato!",
      pieces: 1,
      value: 30
    },
    {
      id: 'banana',
      onTrash: false,
      days: 2,
      src: banana,
      its: "Banana!",
      pieces: 1,
      value: 30,
    },
    {
      id: 'peach',
      onTrash: false,
      days: 2,
      src: peach,
      its: "Peach!",
      pieces: 1,
      value: 20
    },
    {
      id: 'cheescacke',
      onTrash: false,
      days: 4,
      src: cheescacke,
      its: "Cheesecake desert!",
      pieces: 1,
      value: 40
    },
    {
      id: 'cheese',
      onTrash: false,
      days: 5,
      src: cheese,
      its: "Cheese!",
      pieces: 2,
      value: 50
    },
    {
      id: 'salami',
      onTrash: false,
      days: 5,
      src: salami,
      its: "Salami!",
      pieces: 2,
      value: 50
    },
    {
      id: 'sausages',
      onTrash: false,
      days: 5,
      src: sausages,
      its: "Sausages!",
      pieces: 3,
      value: 60
    },
    {
      id: 'egg',
      onTrash: false,
      days: 7,
      src: egg,
      its: "Egg!",
      pieces: 1,
      value: 40
    },
    {
      id: 'egg2',
      onTrash: false,
      days: 7,
      src: egg,
      its: "Egg!",
      pieces: 1,
      value: 40
    },
    {
      id: 'jam',
      onTrash: false,
      days: 99,
      src: jam,
      its: "Jam",
      pieces: 3,
      value: 30
    },
    {
      id: 'paper',
      onTrash: false,
      days: 3,
      src: papper,
      its: "Pepper!",
      pieces: 1,
      value: 30
    },
    {
      id: 'milk',
      onTrash: false,
      days: 4,
      src: milk,
      its: "Milk!",
      pieces: 2,
      value: 20
    },
    {
      id: 'cola',
      onTrash: false,
      days: 99,
      src: cola,
      its: "Soda!",
      pieces: 1,
      value: 30
    },
    {
      id: 'focus',
      onTrash: false,
      days: 99,
      src: focus,
      its: "Focus lemonade!",
      pieces: 2,
      value: 20
    },
    {
      id: 'dory',
      onTrash: false,
      days: 3,
      src: dory,
      its: "Dory yogurt!",
      pieces: 1,
      value: 40
    },
    {
      id: 'dory2',
      onTrash: false,
      days: 3,
      src: dory,
      its: "Dory yogurt!",
      pieces: 1,
      value: 40
    },
    {
      id: 'flakes',
      onTrash: false,
      days: 99,
      src: flakes,
      its: "Flakes, who put it fridge?",
      pieces: 2,
      value: 60
    },
    {
      id: 'spickers',
      onTrash: false,
      days: 99,
      src: spickers,
      its: "Spickers bar!",
      pieces: 1,
      value: 60,
    },
    {
      id: 'energy',
      onTrash: false,
      days: 99,
      src: energy,
      its: "Energy drink!",
      pieces: 1,
      value: 20,
    },
  ]
}

export const LANG = {
  0: 'en',
  1: 'ru',
}

const languages = {
  0: 'En',
  1: 'Рус',
}

const App = () => {
  const { t, i18n } = useTranslation();
  const soundsRef = useRef(null)
  const sounds = useSounds()
  const soundsReverse = useSounds('')
  const soundsFX = useSounds('')

  const {
    onPlay,
    setVolume,
  } = sounds

  const {
    onPlay: onPlayRevers,
    setVolume: setVolumeRevers,
  } = soundsReverse

  const {
    onPlay: onPlayFX,
    setVolume: setVolumeFX,
  } = soundsFX

  const langKey = Number(findKeyByValue(LANG, i18n.language))
  const [curLanguage, setCurLanguage] = useState(langKey)

  const [curView, setCurView] = useState('ExitPage')
  const [lastScreenInGame, setLastScreenInGame] = useState('')

  //ITEMS STORE
  const [products, setProducts] = useState([])


  // TIME STORE #######################
  const [currentDay, setCurrentDay] = useState(8)
  const [currentDeadline, setCurrentDeadline] = useState(0)
  const [currentTime, setCurrentTime] = useState(12)
  const [currentProgress, setCurrentProgress] = useState(0)
  const [foodPoisoning, setFoodPoisoning] = useState(false)

  const [currentHunger, setCurrentHunger] = useState(0)
  const [currentFatigue, setCurrentFatigue] = useState(0)


  const [isMusicStart, setIsMusicStart] = useState(false)
  const [menuVolume, setMenuVolume] = useState(0.05)
  const [menuFxVolume, setMenuFxVolume] = useState(0.5)

  const onUpdateTime = (hrs) => {
   if (currentTime + hrs >= 24) {
     setCurrentDay(prevState => prevState + 1)
     setCurrentTime(currentTime + hrs - 24)
   } else {
     setCurrentTime(prevState => prevState + hrs)
   }
  }

  //START GAME USE EFFECT
  const wrapperRef = useRef()
  useEffect(()=>{
    makeImagesNotDraggable(wrapperRef)
  }, [])

  useEffect(() => {

    if(curView === "ExitPage" || !soundsRef || !sounds || isMusicStart) {
      return
    }

    setIsMusicStart(true)
    setVolume(0.5)
    onPlay(src, "mainTheme",true, soundsRef)
    onPlayRevers(srcRevers, "mainThemeRevers",true, soundsRef)
  }, [soundsRef, sounds, isMusicStart, curView]);

  useEffect(() => {
    if(REVERS_MUSIC.includes(curView)) {
      setVolume(0)
      setVolumeRevers(menuVolume)
    } else {
      if (curView==="ExitPage") {
        setVolume(0)
        setVolumeRevers(0)
        return
      }
      setVolume(menuVolume)
      setVolumeRevers(0)
    }

  }, [curView, menuVolume]);

  useEffect(() => {
    setVolumeFX(menuFxVolume)
  }, [curView, menuFxVolume]);

  const onChangeView = (viewName) => {
    setCurView(viewName)
  }

  const onSetPause = () => {
    onChangeView("MenuPage")
    setLastScreenInGame(curView)
  }

  const onChangeLanguage = (curLang, dir) => {
    const tempCounter = (curLanguage === 0) ? 1 : 0
    changeLanguage(LANG[tempCounter])
    setCurLanguage(tempCounter)
  }

  const onResetGame = (newDeadline) => {
    setLastScreenInGame("")
    setCurrentDay(8)
    setCurrentTime(12)
    setCurrentProgress(0)
    setCurrentHunger(0)
    setCurrentFatigue(0)
    setCurrentDeadline(newDeadline)
    setProducts(PRODUCTS_TEMPLATE[newDeadline])
  }

  return <TranslationProvider>
    <div className="music" ref={soundsRef} />
    <ScalingWrapper nonScaliable>
      <div ref={wrapperRef} className={cx("content-wrapper")}>
        <div className="main">
          {!BAR_NOT_SHOW_IN.includes(curView) && <Header
            onSetPause={onSetPause}
            currentDay={currentDay}
            currentTime={currentTime}
            currentHunger={currentHunger}
            currentFatigue={currentFatigue}
          />}

          {curView === "ExitPage" && <ExitPage onChangeView={onChangeView} />}
          {curView === "CreditsPage" && <CreditsPage onChangeView={onChangeView} />}
          {curView === "MenuPage" && <MenuPage
            onChangeView={onChangeView}
            lastScreenInGame={lastScreenInGame}
            sounds={sounds}
            setMenuVolume={setMenuVolume}
            menuVolume={menuVolume}
            setMenuFxVolume={setMenuFxVolume}
            menuFxVolume={menuFxVolume}
            onChangeLanguage={onChangeLanguage}
            curLanguage={curLanguage}
          />}
          {curView === "NewGamePage" && <NewGamePage
            onChangeView={onChangeView}
            onResetGame={onResetGame}
          />}
          {curView === "PCScreenPage" && <PCScreenPage
            onChangeView={onChangeView}
            onSetPause={onSetPause}
            onUpdateTime={onUpdateTime}
            currentDay={currentDay}
            currentDeadline={currentDeadline}
            currentProgress={currentProgress}
            setCurrentProgress={setCurrentProgress}
            setCurrentHunger={setCurrentHunger}
            setCurrentFatigue={setCurrentFatigue}
            currentHunger={currentHunger}
            currentFatigue={currentFatigue}
            soundsFX={soundsFX}
            soundsRef={soundsRef}
          />}
          {curView === "BedroomPage" && <BedroomPage
            onChangeView={onChangeView}
            onSetPause={onSetPause}
            onUpdateTime={onUpdateTime}
            currentTime={currentTime}
            setCurrentTime={setCurrentTime}
            setCurrentFatigue={setCurrentFatigue}
            currentFatigue={currentFatigue}
            currentHunger={currentHunger}
            setCurrentHunger={setCurrentHunger}
            foodPoisoning={foodPoisoning}
            setFoodPoisoning={setFoodPoisoning}
            soundsFX={soundsFX}
            soundsRef={soundsRef}
          />}
          {curView === "KitchenPage" && <KitchenPage
            onChangeView={onChangeView}
            onSetPause={onSetPause}
            currentTime={currentTime}
            soundsFX={soundsFX}
            soundsRef={soundsRef}
          />}
          {curView === "FridgePage" && <FridgePage
            onChangeView={onChangeView}
            onSetPause={onSetPause}
            currentTime={currentTime}
            currentHunger={currentHunger}
            setCurrentHunger={setCurrentHunger}
            setCurrentFatigue={setCurrentFatigue}
            products={products}
            setProducts={setProducts}
            onResetGame={onResetGame}
            currentDeadline={currentDeadline}
            currentDay={currentDay}
            setCurrentTime={setCurrentTime}
            setFoodPoisoning={setFoodPoisoning}
            soundsFX={soundsFX}
            soundsRef={soundsRef}
          />}
          {curView === "EndGamePage" && <EndGamePage
            onChangeView={onChangeView}
            currentProgress={currentProgress}
            currentDeadline={currentDeadline}
            soundsFX={soundsFX}
            soundsRef={soundsRef}
          />}
        </div>
        <Loader />
      </div>
    </ScalingWrapper>
  </TranslationProvider>
}

export default App;

